export default "__VITE_ASSET__fbf56159__"